import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=aefe7a5c&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=js&"
export * from "./Setup.vue?vue&type=script&lang=js&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=aefe7a5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefe7a5c",
  null
  
)

export default component.exports